import uploadIcon from "@/shared/icons/components/UploadIcon/assets/upload.svg";
import { UploadIconProps } from "@/shared/icons/components/UploadIcon/type";

export const UploadIcon = (props: UploadIconProps) => {
  const alt = props.alt ?? "upload icon";
  return <img src={uploadIcon} alt={alt} {...props} />;
};
